<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->

<div class="modal-header">
  <h5 class="modal-title" [xdaTranslate]="'SDE_SECURITY_LEVELS'"></h5>
</div>
<div class="modal-body" tabindex="-1">
  <label [xdaTranslate]="'SDE_TRACK_VIEWS'"></label>
  <div [xdaTranslate]="'SDE_TRACK_NUMBER_DOCUMENT'"></div>
  <label [xdaTranslate]="'SDE_TRACK_VIEWERS'"></label>
  <div [xdaTranslate]="'SDE_TRACK_NUMBER_DOCUMENT1'"></div>
  <label [xdaTranslate]="'SDE_RESTRICT_TRACK_VIEWERS'"></label>
  <div [xdaTranslate]="'SDE_TRACK_NUMBER_DOCUMENT2'"></div>
</div>
<div class="modal-footer">
  <div class="modal-footer-right">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-primary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CLOSE'"></span>
      </button>
    </div>
  </div>
</div>
